/* CappyRevolution · Patch-Picker (assets/cr-picker.js)
   Kategorie-Chips, Suche nach Code oder Motiv, Raster. Daten: snippets/cr-patch-data.liquid (JSON).
   Genutzt von Konfigurator (Startseite) und Produktseite. */
(function () {
  'use strict';
  const CR = (window.CR = window.CR || {});
  CR.patchData = (id) => { try { return JSON.parse(document.getElementById(id)?.textContent || '[]'); } catch (_) { return []; } };
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  CR.patchLabel = (p) => (p.c ? `${p.c} · ${p.n}` : p.n);

  /* opts: {data, grid, chips, search, count, selected (Handle), onPick(patch), light} */
  CR.mountPicker = ({ data, grid, chips, search, count, selected, onPick, light = false }) => {
    const pool = data.filter((p) => p.a !== false);
    const cats = ['Alle', ...new Set(pool.map((p) => p.k))];
    let cat = 'Alle', q = '', sel = selected;
    if (light) grid.classList.add('cr-picker--light');
    grid.setAttribute('role', 'listbox');
    grid.setAttribute('aria-label', 'Patches');
    if (chips) {
      chips.innerHTML = cats.map((c) => `<button type="button" class="cr-chip" aria-pressed="${c === cat}" data-cat="${esc(c)}">${esc(c)}</button>`).join('');
      chips.addEventListener('click', (e) => {
        const b = e.target.closest('[data-cat]'); if (!b) return;
        cat = b.dataset.cat; [...chips.children].forEach((x) => x.setAttribute('aria-pressed', x === b)); draw();
      });
    }
    if (search) search.addEventListener('input', () => { q = search.value.trim().toLowerCase(); draw(); });
    grid.addEventListener('click', (e) => {
      const b = e.target.closest('[data-p]'); if (!b) return;
      sel = b.dataset.p;
      [...grid.querySelectorAll('[data-p]')].forEach((x) => x.setAttribute('aria-selected', x === b));
      onPick(pool.find((p) => p.h === sel));
    });
    function draw() {
      const list = pool.filter((p) => (cat === 'Alle' || p.k === cat) && (!q || `${p.c} ${p.n}`.toLowerCase().includes(q)));
      grid.innerHTML = list.map((p) => `<button type="button" role="option" class="cr-pk" data-p="${esc(p.h)}" aria-selected="${p.h === sel}" title="${esc(CR.patchLabel(p))}"><img src="${esc(CR.img(p.i, 180))}" alt="Patch ${esc(p.n)}" loading="lazy" width="90" height="90"><small>${esc(p.c && p.c.length <= 5 ? p.c : p.n.split(' ')[0])}</small></button>`).join('')
        || '<p style="grid-column:1/-1;margin:0;opacity:.7">Kein Patch gefunden. Probier einen Code wie „T1“ oder ein Motiv wie „Löwe“.</p>';
      if (count) count.textContent = list.length + ' Patches';
    }
    draw();
    return { set(h) { sel = h; draw(); }, get: (h) => pool.find((p) => p.h === h), pool };
  };
})();
